import React, { useRef, useEffect } from "react";
import { Typography } from "@mui/material";
import InfoIconButton from "./InfoIconButtonComponent";
import ProjectLocationMap from "./ProjectLocationComponent";
import "../../static/project-dashboard-styles.css";

const ProjectLocationSection = ({ projectData }) => {
	const gmapsAPI = process.env.REACT_APP_GOOGLE_API_KEY;


	return (
		<>
		<div className="card-content-header card-content-header-padded">
			<Typography
			variant="subtitle1"
			className="card-title"
			style={{ textAlign: "left", verticalAlign: "top" }}
			>
			Project Location
			</Typography>
			<InfoIconButton projectData={projectData} source="projectLocation" />
		</div>
		<ProjectLocationMap
			projectData={projectData}
			gmapsAPI={gmapsAPI}
		/>
		</>
	);
};

export default ProjectLocationSection;
